module.exports = __webpack_public_path__ + "static/media/KLBackground.8c41b6f3.png";